import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import IosSwitch from 'react-ios-switch'
import { useStateValue } from '../../state'
import { client } from '@Utils'
import ButterToast, { Cinnamon } from 'butter-toast'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import { EditDeploymentModal } from '../modals/EditDeploymentModal'

export const Deployment = ({ match }) => {
  const [currentState, dispatch] = useStateValue()

  const [editInstanceModalOpen, setEditInstanceModalOpen] = useState(false)

  const [removeContextModalOpen, toggleRemoveModal] = useState(false)
  const [removeContextURL, setRemoveContextURL] = useState('')
  const [removeContextMessage, setRemoveContextMessage] = useState('')

  useEffect(() => {
    const getContexts = async () => {
      try {
        let resp = await client.get(
          `/account/admin_lti13.getContexts/-/${match.params.issuerId}/${match.params.clientId}/${match.params.deploymentId}/`
        )
        dispatch({ type: 'updateMessage', message: null })
        dispatch({ type: 'updateIssuer', issuer: resp.data.issuer })
        dispatch({ type: 'updateClient', client: resp.data.client })
        dispatch({ type: 'updateDeployment', deployment: resp.data.deployment })
        dispatch({
          type: 'updateContextsTable',
          contextsTableData: resp.data.contexts,
        })
      } catch (err) {
        if (err.response) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
          ButterToast.raise({
            content: (
              <Cinnamon.Crisp
                title={err.response.statusText}
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-thumbs-down fa-3x" />}
              />
            ),
          })
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      }
    }
    getContexts()
  }, [currentState.reloadSwitch])

  const openModal = contextObject => {
    setRemoveContextURL(
      `/account/admin_lti13.deleteContext/-/${contextObject.id}/`
    )
    setRemoveContextMessage(
      `Are you sure you want to remove ${contextObject.contextTitle}?`
    )
    toggleRemoveModal(true)
  }

  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-4">
        <Link
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}`}
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </Link>
      </div>
      <div className="card-myed w-100">
        <div className="pi-info pull-right">
          <button
            onClick={() => setEditInstanceModalOpen(true)}
            className="btn btn-sm btn-sm-myed btn-primary"
          >
            Edit <i className="far fa-edit" />
          </button>
        </div>
        <h3>Deployment:</h3>
        {currentState.issuer && currentState.client && currentState.deployment && (
          <div>
            <div className="pull-right">
              <p>Enable LTI 1.3 Connection: </p>
              <IosSwitch
                style={{ transform: 'scale(0.6)' }}
                onChange={async () => {
                  let data = {
                    lti_login: !currentState.deployment.data.lti_login,
                  }
                  try {
                    let resp = await client.post(
                      `/account/admin_lti13.lti_login/-/${match.params.issuerId}/${match.params.clientId}/${match.params.deploymentId}`,
                      data
                    )
                    dispatch({
                      type: 'updateDeployment',
                      deployment: resp.data.deployment,
                    })
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="LTI Login Status Updated!"
                          content={`LTI login is now: ${
                            resp.data.deployment.data.lti_login
                              ? 'Enabled'
                              : 'Disabled'
                          }`}
                          scheme={
                            resp.data.deployment.data.lti_login
                              ? Cinnamon.Crisp.SCHEME_GREEN
                              : Cinnamon.Crisp.SCHEME_ORANGE
                          }
                          icon={
                            resp.data.deployment.data.lti_login ? (
                              <i className="far fa-check fa-3x" />
                            ) : (
                              <i className="far fa-exclamation-triangle fa-3x" />
                            )
                          }
                        />
                      ),
                    })
                  } catch (err) {
                    ButterToast.raise({
                      content: (
                        <Cinnamon.Crunch
                          title="Error"
                          content={`There was an error trying to toggle the Login status: ${err}`}
                          scheme={Cinnamon.Crisp.SCHEME_RED}
                          icon={
                            <i className="far fa-exclamation-triangle fa-3x" />
                          }
                        />
                      ),
                    })
                  }
                }}
                checked={currentState.deployment.data.lti_login}
              />
              {['blackboard'].includes(match.params.lmsCode) && (
                <p>Deployments should be enabled for Blackboard</p>
              )}
            </div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                ID:
              </span>{' '}
              {currentState.deployment.id}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Deployment ID:
              </span>{' '}
              {currentState.deployment.deploymentid}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Name:
              </span>{' '}
              {currentState.deployment.data.name}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Connection Enabled:{' '}
              </span>{' '}
              {currentState.deployment.data.lti_login ? 'Yes' : 'No'}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Issuer:{' '}
              </span>{' '}
              {`${currentState.issuer.data.name} (${currentState.issuer.iss}) [${currentState.issuer.id}]`}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Client:{' '}
              </span>{' '}
              {`${currentState.client.data.name} [${currentState.client.id}]`}
            </p>
          </div>
        )}
      </div>
      <div className="card-myed d-inline-block">
        <h3>Contexts</h3>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>Id</th>
              <th>Context Id</th>
              <th>Context Title</th>
              <th style={{ minWidth: 90 }}>Context Label</th>
              <th style={{ minWidth: 90 }}>Create Date</th>
              <th>Links</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentState.contextsTableData &&
              currentState.contextsTableData.map((context, i) => {
                console.log('CONTEXT :: ', context)

                const lineItemsUrl = context.lineItems ? (
                  context.lineItems
                ) : (
                  <i
                    className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                  />
                )

                const namesRolesUrl = context.namesRoles ? (
                  context.namesRoles
                ) : (
                  <i
                    className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                  />
                )

                const redOutlineStyle = { border: '2px solid red' }

                const missingEndpointStyle = context.lineItems
                  ? {}
                  : redOutlineStyle
                return (
                  <tr key={i} style={missingEndpointStyle}>
                    <td>{context.id}</td>
                    <td>{context.contextId}</td>
                    <td>{context.contextTitle}</td>
                    <td>{context.contextLabel}</td>
                    <td>{new Date(context.createDate).toLocaleString()}</td>
                    <td>
                      <p>Line Items: {lineItemsUrl}</p>
                      <p>Names/Roles: {namesRolesUrl}</p>
                    </td>
                    <td>
                      <Link
                        to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${context.id}`}
                      >
                        View Context
                      </Link>
                    </td>
                    <td>
                      <a
                        onClick={() => openModal(context)}
                        className="btn btn-sm btn-sm-myed btn-danger"
                      >
                        Remove <i className="far fa-window-close" />
                      </a>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
        <EditDeploymentModal
          show={editInstanceModalOpen}
          toggle={setEditInstanceModalOpen}
          deployment={currentState.deployment}
        />
        <RemoveConfirmModal
          modalTitle="Remove Context"
          message={removeContextMessage}
          endpoint={removeContextURL}
          show={removeContextModalOpen}
          toggle={toggleRemoveModal}
          currentState={currentState}
          dispatch={dispatch}
        />
      </div>
    </div>
  )
}
